import { CompanyProfile, VatMode } from '../types';

export const DEFAULT_INJURIES_RATE = 0.2;

export const VAT_MODE_LABELS: Record<VatMode, string> = {
    EXEMPT: 'Освобождение от НДС',
    USN_5: 'НДС 5% (без вычетов)',
    USN_7: 'НДС 7% (без вычетов)',
    GENERAL: 'Общая ставка 22% с вычетами',
};

// Режим НДС за год (как tax.vat_mode_for на бэкенде): ОСНО — общая ставка, УСН — последняя запись не позже года
export const vatModeFor = (org: CompanyProfile | undefined, year: number): VatMode => {
    if (!org?.taxSystem?.includes('УСН')) return 'GENERAL';
    const modes = (org.vatModes || []).filter(m => m.year <= year);
    if (!modes.length) return 'EXEMPT';
    return modes.reduce((a, b) => (b.year > a.year ? b : a)).mode;
};

export const vatRateForMode = (mode: VatMode, year: number): number =>
    mode === 'GENERAL' ? (year >= 2026 ? 22 : 20) : mode === 'USN_5' ? 5 : mode === 'USN_7' ? 7 : 0;

// Ставка НДС по умолчанию для выручки на дату
export const incomeVatRateFor = (org: CompanyProfile | undefined, date: string): number => {
    const year = new Date(date).getFullYear();
    return vatRateForMode(vatModeFor(org, year), year);
};

// Тариф на травматизм за год: последняя запись с годом не позже нужного (как tax.injuries_rate_for на бэкенде)
export const injuriesRateFor = (org: CompanyProfile | undefined, year: number): number => {
    const rates = (org?.injuriesRates || []).filter(r => r.year <= year);
    if (!rates.length) return DEFAULT_INJURIES_RATE;
    return rates.reduce((a, b) => (b.year > a.year ? b : a)).ratePercent;
};
